import React from "react";

export default function TopSection(props){
    const {children} = props;
    return <section className="c-top-section">
        {children}
    </section>;
}